const ClientManage = () =>
  import(
    /* webpackChunkName: "company" */ "@/app/admin/client/clientmanage/clientmanage"
  );

const HrManage = () =>
  import(
    /* webpackChunkName: "company" */ "@/app/admin/client/hrmanage/hrmanage"
  );

const Contract = () =>
  import(
    /* webpackChunkName: "resume" */ "@/app/admin/client/clientmanage/contract"
  );

export default [
  {
    path: "client-manage",
    name: "clientmanage",
    component: ClientManage,
    meta: { title: "客户管理", key: "client-manage", keepAlive: true }
  },
  {
    path: "hr-manage",
    name: "hrmanage",
    component: HrManage,
    meta: { title: "HR管理", key: "hr-manage" }
  },
  {
    path: "client-manage/contract",
    name: "contract",
    component: Contract,
    meta: { title: "签约合同", key: "client-manage" }
  }
];
